/* istanbul ignore file */
import React, { useEffect } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import { fetchLinkList, selectLinkListCrudStatus } from '../../../redux/slices/linkListSlice/linkListSlice';
import { fetchTagList, selectTagListCrudStatus } from '../../../redux/slices/tagListSlice/tagListSlice';
import ManageSearchLayout from '../../search/ManageSearchLayout';
import searchType from '../../../utility/types/SearchType';
import { clearActiveSearch } from '../../../redux/slices/savedSearchesSlice/savedSearchesSlice';
import {
  selectIsDeviceListLocalStorageLoaded,
} from '../../../redux/slices/filteredDeviceListSlice/filteredDeviceListSlice';
import { CrudStatus } from '../../../utility/types/CrudStatus';
import DeviceListLayout from './DeviceListLayout/DeviceListLayout';
import DeviceDetailsPage from '../DeviceDetailsPage/DeviceDetailsPage';
import RaaRoute from '../../common/RaaRoute';

function DevicesPage() {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const localStorageLoaded = useSelector(selectIsDeviceListLocalStorageLoaded);
  const tagsCrudStatus = useSelector((state) => selectTagListCrudStatus(state));
  const linkCrudStatus = useSelector((state) => selectLinkListCrudStatus(state));

  useEffect(() => {
    if (tagsCrudStatus === CrudStatus.IDLE || tagsCrudStatus === CrudStatus.PENDING) {
      dispatch(fetchTagList());
    }
    if (linkCrudStatus === CrudStatus.IDLE || linkCrudStatus === CrudStatus.PENDING) {
      dispatch(fetchLinkList());
    }
    return () => { dispatch(clearActiveSearch()); };
  }, [dispatch]);

  if (!localStorageLoaded || tagsCrudStatus === CrudStatus.PENDING) {
    return (
      <div className="row d-flex justify-content-center mt-5">
        <div><ProgressSpinner progressText="Loading..." /></div>
      </div>
    );
  }

  return (
    <Switch>
      <RaaRoute path="/s/devices" exact>
        <DeviceListLayout />
      </RaaRoute>
      <RaaRoute path="/s/devices/saved-searches">
        <ManageSearchLayout searchType={searchType.DEVICE} />
      </RaaRoute>
      <RaaRoute path={`${path}/:id`}>
        <DeviceDetailsPage />
      </RaaRoute>
    </Switch>
  );
}

export default DevicesPage;
